export {};
//# sourceMappingURL=SocketClient.js.map